import {
  getFormData,
  resetFormErrors,
  showFormErrors
} from '../../utils/form';
import * as notification from '../../components/notifications';

let deleteAccountModal;
let confirmDeleteAccountBtn;
let deleteAccountForm;

const initPage = () => {
  deleteAccountModal = $("#modal-delete-account");

  if (!deleteAccountModal) {
    return;
  }
  confirmDeleteAccountBtn = $(".btn-modal-confirm", deleteAccountModal);
  deleteAccountForm = $("#delete-account-form", deleteAccountModal)

  deleteAccountModal.submit(function() {
    confirmDeleteAccount();
    return false;
  })

  $("#delete-account-btn").click(askToDeleteAccount);
  confirmDeleteAccountBtn.click(confirmDeleteAccount);
};

const askToDeleteAccount = () => {
  deleteAccountModal.modal('show');
};

const confirmDeleteAccount = async () => {
  confirmDeleteAccountBtn.loading();

  try {
    let response = await axios.delete("/api/users/current", {data: getFormData(deleteAccountForm)});
    resetFormErrors(deleteAccountForm);

    notification.success(response.data.message);

    const redirectUrl = response.data.redirect_url || '/';

    setTimeout(() => {
      window.location.replace(redirectUrl);
    }, 1000)
  } catch (e) {
    $("#password", deleteAccountForm).val('');
    confirmDeleteAccountBtn.loading(false);
    showFormErrors(deleteAccountForm, e.response);
  }
};

$(initPage);
